<template>
<div class="operate_left blue">
  <door-box :height="812" width="100%">
     <div class="box_wrap">
       <div class="top">
         <div class="left_title">
           超低排放过程介绍
         </div>
         <introduce></introduce>
       </div>
       <div class="bottom">
         <time-line></time-line>
       </div>
     </div>
  </door-box>
</div>
</template>

<script>
import introduce from './component/enterpriseIntroduce';
import timeLine from './component/timeLine';
import doorBox from '../components/doorBox';
export default {
  name: 'index',
  components: { doorBox,introduce,timeLine },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.operate_left {
  // border: 1px solid green;
  height: 100%;
  @include bg-box(100%, 100%, 'left_big.png');
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  transition: none 0s ease 0s;
  .isBaoSteel {
    background: #020F3F;
  }
  .box_wrap {
    height: 100%;
    .top {
      height: 34%;
      margin-bottom: 10px;
      .left_title {
        font-size: 30px;
        color: #63F2EF;
        font-weight: 600;
        margin-bottom: 20px;
      }
    }
    .bottom {
      height: 65%;
      padding-left: 15px;
      padding-right: 10px;
      padding-top: 10px;
    }
  }
}
.blue {
  //background: rgba(0, 106, 255, 0.05);
  border: 1px solid rgba(132, 170, 255, 0.5);
}
</style>
